/* global Atls */
import $ from "jquery";
import { logger } from "./logger";

function init() {
    loadModules();
}

function loadModules() {
    let allModules = [];
    $("[data-modules]").each(function() {
        const modules = $(this)
            .attr("data-modules")
            .split(",");
        modules.forEach(function(value, index) {
            modules[index] = value.trim();
        });
        allModules = allModules.concat(modules);
    });

    allModules.map(function(module) {
        if (module && Atls[module.trim()] && $.isFunction(Atls[module.trim()].init)) {
            Atls[module.trim()].init();
        } else {
            logger.critical("core.js: Unable to load module: " + module);
        }
    });
}

function loadOneModule(module) {
    if (module && Atls[module.trim()] && $.isFunction(Atls[module.trim()].init)) {
        Atls[module.trim()].init();
    } else {
        logger.critical("core.js: Unable to load module: " + module);
    }
}

export const core = {
    init: init,
    loadOneModule: loadOneModule
};
